import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Pencil, Trash2, Megaphone } from "lucide-react";
import { ViewOnlyBanner } from "./ViewOnlyBanner";

export const BannersTab = ({
  darkMode, banners, deleteBanner,
  setEditingBanner, setBannerForm, setBannerDialogOpen, viewOnly
}) => {
  const cardBg = darkMode ? "bg-gray-800/80 border border-gray-700/50" : "";

  return (
    <>
    {viewOnly && <ViewOnlyBanner darkMode={darkMode} />}
    <Card className={`border-0 shadow-soft rounded-3xl ${cardBg}`}>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className={darkMode ? "text-gray-100" : ""}>Promotional Banners</CardTitle>
        {!viewOnly && (
        <Button onClick={() => { setEditingBanner(null); setBannerForm({ title: "", subtitle: "", cta_text: "Shop Now", cta_link: "/mock-exams", bg_color: "#dc2626", text_color: "#ffffff", is_active: true, starts_at: "", expires_at: "" }); setBannerDialogOpen(true); }} className="rounded-xl bg-primary" data-testid="add-banner-btn">
          <Plus className="w-4 h-4 mr-2" /> Add Banner
        </Button>
        )}
      </CardHeader>
      <CardContent>
        {banners.length > 0 ? (
          <div className="space-y-4">
            {banners.map(banner => (
              <div key={banner.id} className={`border rounded-2xl overflow-hidden ${darkMode ? "border-gray-700" : ""}`} data-testid={`banner-item-${banner.id}`}>
                <div className="p-4 flex items-center justify-between" style={{ backgroundColor: banner.bg_color, color: banner.text_color }}>
                  <div>
                    <p className="font-bold text-lg">{banner.title}</p>
                    {banner.subtitle && <p className="text-sm opacity-80">{banner.subtitle}</p>}
                  </div>
                  {banner.cta_text && (
                    <span className="px-4 py-1.5 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium">
                      {banner.cta_text}
                    </span>
                  )}
                </div>
                <div className={`p-4 flex items-center justify-between text-sm ${darkMode ? "bg-gray-800" : "bg-white"}`}>
                  <div className={`flex items-center gap-4 ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${banner.is_active ? (darkMode ? "bg-green-900/30 text-green-400" : "bg-green-100 text-green-700") : (darkMode ? "bg-gray-700 text-gray-400" : "bg-gray-100 text-gray-500")}`}>
                      {banner.is_active ? "Active" : "Inactive"}
                    </span>
                    {banner.starts_at && <span>From: {new Date(banner.starts_at).toLocaleDateString()}</span>}
                    {banner.expires_at && <span>Until: {new Date(banner.expires_at).toLocaleDateString()}</span>}
                    <span>Link: {banner.cta_link}</span>
                  </div>
                  {!viewOnly && (
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm" className={`rounded-lg ${darkMode ? "bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600" : ""}`} onClick={() => { setEditingBanner(banner); setBannerForm({ title: banner.title, subtitle: banner.subtitle || "", cta_text: banner.cta_text || "Shop Now", cta_link: banner.cta_link || "/mock-exams", bg_color: banner.bg_color || "#dc2626", text_color: banner.text_color || "#ffffff", is_active: banner.is_active, starts_at: banner.starts_at || "", expires_at: banner.expires_at || "" }); setBannerDialogOpen(true); }} data-testid={`edit-banner-${banner.id}`}>
                      <Pencil className="w-3 h-3" />
                    </Button>
                    <Button variant="destructive" size="sm" className="rounded-lg" onClick={() => deleteBanner(banner.id)} data-testid={`delete-banner-${banner.id}`}>
                      <Trash2 className="w-3 h-3" />
                    </Button>
                  </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Megaphone className={`w-16 h-16 mx-auto mb-4 ${darkMode ? "text-gray-600" : "text-muted-foreground"}`} />
            <p className={`mb-4 ${darkMode ? "text-gray-400" : "text-muted-foreground"}`}>No promotional banners yet</p>
            {!viewOnly && (
            <Button onClick={() => setBannerDialogOpen(true)} className="rounded-xl">
              <Plus className="w-4 h-4 mr-2" /> Create First Banner
            </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
    </>
  );
};
